// Generated by ReScript, PLEASE EDIT WITH CARE

import * as View from "../primitives/View.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as DesignSystemRoutes from "./DesignSystemRoutes.res.js";
import * as ElectronicInvoicingWorkflowState from "../modules/ElectronicInvoicing/ElectronicInvoicingWorkflowState.res.js";
let pages = [ElectronicInvoicingWorkflowState.designSystemPage];
let styles = {
  layout: {
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "margin-kogj98": "margin-xhifcr4",
    $$css: "wino-gc:src/app/DesignSystemPage.res.js:13"
  },
  nav: {
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-x1q0g3np",
    "gap-kOIVth": "gap-x1v2ro7d",
    $$css: "wino-gc:src/app/DesignSystemPage.res.js:18"
  }
};
let layoutCss = {
  className: "display-x78zum5 flexDirection-xdt5ytf margin-xhifcr4",
  "data-style-src": "wino-gc:src/app/DesignSystemPage.res.js:13"
};
let navCss = {
  className: "display-x78zum5 flexDirection-x1q0g3np gap-x1v2ro7d",
  "data-style-src": "wino-gc:src/app/DesignSystemPage.res.js:18"
};
function DesignSystemPage$Layout(props) {
  let __children = props.children;
  let children = __children !== undefined ? __children : null;
  let newrecord = {
    ...layoutCss
  };
  let newrecord$1 = {
    ...navCss
  };
  newrecord.children = [JsxRuntime.jsx("h1", {
    children: "Design system"
  }), JsxRuntime.jsx("nav", (newrecord$1.children = View.map(pages, param => {
    let route = param.route;
    return JsxRuntime.jsxs("a", {
      children: ["| ", route, " |"],
      href: DesignSystemRoutes.baseRoute + "/" + route
    });
  }), newrecord$1)), children];
  return JsxRuntime.jsxs("div", newrecord);
}
let Layout = {
  make: DesignSystemPage$Layout
};
function DesignSystemPage$Router(props) {
  let subUrlPath = props.subUrlPath;
  let page = pages.find(param => Primitive_object.equal({
    hd: param.route,
    tl: /* [] */0
  }, subUrlPath));
  return JsxRuntime.jsx(DesignSystemPage$Layout, {
    children: page !== undefined ? page.view() : null
  });
}
let Router = {
  make: DesignSystemPage$Router
};
export { pages, styles, layoutCss, navCss, Layout, Router };
/* styles Not a pure module */